import BillingsOrderCargoRailyDraftRequest from "../../../../../api/raily/billings/order/cargo-raily/draft/billings-order-cargo-raily-draft.request";
import BillingsOrderCargoRailyDraftParams from "./billings-order-cargo-raily-draft-params";

const create = (
  params: BillingsOrderCargoRailyDraftParams,
): BillingsOrderCargoRailyDraftRequest => {
  return {
    orderUuid: params.orderUuid,
  };
};

const billingsOrderCargoRailyDraftParamsFactory = {
  create,
};

export default billingsOrderCargoRailyDraftParamsFactory;
